import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b70fa276"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "column field" };
const _hoisted_2 = { style: { "display": "flex" } };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Signature *", -1));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mb-2" }, "Draw your signature on the signature pad.", -1));
import { ref } from "vue";
import SignaturePad from 'vue3-signature-pad';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SignaturePadField',
    setup(__props, { expose: __expose }) {
        const signaturePad = ref(null);
        const isSignatureEmpty = () => {
            return signaturePad.value.isEmpty();
        };
        const getSignatureData = () => {
            return signaturePad.value.saveSignature().data;
        };
        __expose({
            isSignatureEmpty,
            getSignatureData
        });
        return (_ctx, _cache) => {
            const _component_SaveButton = _resolveComponent("SaveButton");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _renderSlot(_ctx.$slots, "top"),
                    _createVNode(_component_SaveButton, {
                        class: "ml-2",
                        label: "Clear",
                        icon: "fa-eraser",
                        onClick: _cache[0] || (_cache[0] = ($event) => (signaturePad.value.clearSignature()))
                    })
                ]),
                _hoisted_4,
                _createVNode(_unref(SignaturePad), {
                    id: "pad",
                    ref_key: "signaturePad",
                    ref: signaturePad
                }, null, 512)
            ]));
        };
    }
});
